module.exports = __webpack_public_path__ + "img/case.ab9f4ac0.png";